export default __webpack_public_path__ + "static/media/Snaketooth Dagger.140a5b79.jpg";